export function deployAndUseDTO(data) {
  return {
    ...data,
    placeRadars: data?.proptechCompanyDetails?.proptechRadarValues
  }
}
